module.exports = __webpack_public_path__ + "img/minions.ab6485a6.png";